<template>
    <div class="container">
        <div class="row">

            <div class="col">
                <div class="display-2">{{ $t("pages.errauth.lbl_head") }}</div>
                <div class="lead">{{ $t("pages.errauth.lbl_body") }}</div>
                <div>
                    <button class="btn btn-light" @click.prevent="fnNavTo('/landing')">
                        {{ $t("common.btn_ok") }}
                    </button>
                </div>
            </div>

        </div>
        <div class="row">

            <div class="col">
                <div>Expired: {{ $store.getters.isAuthenticatedExpired }}</div>
            </div>

        </div>
    </div>
</template>
<script>
    export default {
        name: "ErrAuth",
        data() {
            return {};
        },
        methods: {
            fnNavTo(to) {
                this.$router.push(to);
            },
        },
    };
</script>
